import { faArrowDown, faArrowUp } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { CircularProgress, Grid } from '@material-ui/core';
import React, { useEffect, useState, Fragment } from 'react';
import NumberFormat from 'react-number-format';
import classes from '../UnitEconomics.module.css';
import PercentTip from '../../../components/PercentTip/PercentTip';

//TODO: Ejemplo de como debe quedar un hook
const MRR = props => {
	const [booleanMayor, setBooleanMayor] = useState(false);
	//const [booleanClasificacion, setBooleanClasificacion] = useState(true);
	const [percentChange, setPercentChange] = useState(0);
	const [monthYear, setMonthYear] = useState('');

	const { isLoading, mrrMensual, mrrAnual, mrrAnualAnterior, mrrMensualAnterior, clasificacion } = props;

	const formatDate = dateToTransform => {
		var date = new Date(dateToTransform);

		var monthNames = [
			'Enero',
			'Febrero',
			'Marzo',
			'Abril',
			'Mayo',
			'Junio',
			'Julio',
			'Agosto',
			'Septiembre',
			'Octubre',
			'Noviembre',
			'Diciembre',
		];

		//var day = date.getUTCDate();
		var monthIndex = date.getUTCMonth();
		var year = date.getUTCFullYear();

		return monthNames[monthIndex] + ' ' + year;
	};

	useEffect(() => {
		if (isLoading === false) {
			setPercentChange((1 - (mrrMensualAnterior.mrr + mrrAnualAnterior.mrrPlanAnual) / (mrrMensual.mrr + mrrAnual.mrrPlanAnual)) * 100);
		}
	}, [isLoading, mrrMensualAnterior.mrr, mrrAnualAnterior.mrrPlanAnual, mrrMensual.mrr, mrrAnual.mrrPlanAnual]);

	useEffect(() => {
		const updatePercent = async () => {
			if (percentChange !== 0) {
				if (percentChange < 0) {
					setBooleanMayor(true);
				} else {
					setBooleanMayor(false);
				}
			}
		};
		updatePercent();
	});

	useEffect(() => {
		if (isLoading === false) {
			setMonthYear(formatDate(mrrMensual.dateFrom));
		}
	}, [isLoading, mrrMensual.dateFrom]);

	return (
		<React.Fragment>
			<div className={classes.headerTitle}>MRR</div>

			<div className={classes.date}>{monthYear}</div>
			{isLoading ? (
				<CircularProgress />
			) : (
				<Fragment>
					<div className={classes.number}>
						<NumberFormat
							value={mrrMensual.mrr + mrrAnual.mrrPlanAnual}
							displayType={'text'}
							thousandSeparator={true}
							prefix={'US$'}
							decimalScale={0}
						/>
					</div>

					{booleanMayor ? (
						<FontAwesomeIcon className={classes.faArrowDown} icon={faArrowDown} />
					) : (
						<FontAwesomeIcon className={classes.faArrowUp} icon={faArrowUp} />
					)}
					<br></br>
					{clasificacion ? (
						<Fragment>
							<div className={classes.percent}>
								<PercentTip
									value={<NumberFormat value={percentChange} displayType={'text'} decimalScale={2} suffix={'%'} />}
									percentChange={percentChange}
									text={
										<Fragment>
											<div>Comparación con el Mes Anterior</div>
											<br></br>
											<div>
												<NumberFormat
													value={mrrMensualAnterior.mrr + mrrAnualAnterior.mrrPlanAnual}
													displayType={'text'}
													thousandSeparator={true}
													prefix={'US$'}
													decimalScale={0}
												/>
											</div>
										</Fragment>
									}
								/>
							</div>
						</Fragment>
					) : (
						<div className={classes.percent}>
							<Grid container direction="row" justify="center" alignItems="center">
								<Grid container spacing={2}>
									<Grid item xs={4}>
										<PercentTip
											value={<NumberFormat value={percentChange} displayType={'text'} decimalScale={2} suffix={'%'} />}
											percentChange={percentChange}
											text={
												<Fragment>
													<div>Comparación con el Mes Anterior</div>
													<br></br>
													<div>
														<NumberFormat
															value={mrrMensualAnterior.mrr + mrrAnualAnterior.mrrPlanAnual}
															displayType={'text'}
															thousandSeparator={true}
															prefix={'US$'}
															decimalScale={0}
														/>
													</div>
												</Fragment>
											}
										/>
									</Grid>

									<Fragment>
										<Grid item xs={4}>
											<PercentTip
												value={
													<NumberFormat
														value={
															((mrrMensual.mrrPyme + mrrAnual.mrrPlanAnualPyme) /
																(mrrMensual.mrr + mrrAnual.mrrPlanAnual)) *
															100
														}
														displayType={'text'}
														decimalScale={2}
														suffix={'%'}
														text={'Pymes'}
													/>
												}
												text={
													<Fragment>
														<div>% Pymes</div>
														<br></br>
														<div>
															<NumberFormat
																value={mrrMensual.mrrPyme + mrrAnual.mrrPlanAnualPyme}
																displayType={'text'}
																thousandSeparator={true}
																prefix={'US$'}
																decimalScale={0}
															/>
														</div>
													</Fragment>
												}
												pyme={true}
											/>
										</Grid>
										<Grid item xs={4}>
											<PercentTip
												value={
													<NumberFormat
														value={
															((mrrMensual.mrrCorp + mrrAnual.mrrPlanAnualCorp) /
																(mrrMensual.mrr + mrrAnual.mrrPlanAnual)) *
															100
														}
														displayType={'text'}
														decimalScale={2}
														suffix={'%'}
														text={'Corp'}
													/>
												}
												text={
													<Fragment>
														<div>% Corp</div>
														<br></br>
														<div>
															<NumberFormat
																value={mrrMensual.mrrCorp + mrrAnual.mrrPlanAnualCorp}
																displayType={'text'}
																thousandSeparator={true}
																prefix={'US$'}
																decimalScale={0}
															/>
														</div>
													</Fragment>
												}
												corp={true}
											/>
										</Grid>
									</Fragment>
								</Grid>
							</Grid>
						</div>
					)}
				</Fragment>
			)}
		</React.Fragment>
	);
};

export default React.memo(MRR);
